import application_settings from '../applicationSettings';
import Event from './Event';

class CalculateLoyaltyPoints extends Event {
    eventName = 'oms_calculateLoyaltyPoints';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for calculate loyalty points
     * @event oms_calculateLoyaltyPoints
     * 
     * @param {string} amount - required - subtotal
     * @param {string} contact_no - required - contact number
     * @return void
     * 
     * @eventSuccess oms_calculateLoyaltyPointsSuccess
     * @eventSuccessResponse {"result":{"action":null,"auth_type":"public","logout":null,"client_id":"a2f9a33d84074961b2368602ca9bf9b7","success":true,"message":null,"data":{},"total":null}}
     * @eventFail oms_calculateLoyaltyPointsFail
     * @eventFailResponse test
     *  
     */
    eventFunction(data) {
        let amount = data.amount;
        let contact_no = data.contact_no;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (amount && contact_no) {
            data.endPoint = application_settings.endPoints.loyaltyPoints;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                amount: amount,
                contact_no: contact_no
            };
            
            this.sendRequest(data, function(response) {
                if (response) {
                    //format response data
                    let data = thisObj.formatResponseData(response);

                    //fire success event
                    thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
                }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "amount & contact_no is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default CalculateLoyaltyPoints;